import { Tooltip } from '@postscript/components';
import { nanoid } from 'nanoid';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const DISABLED_MESSAGE =
  'You have view-only access. Contact your Admin to request edit permissions.';

const StyledTooltip = styled(Tooltip)`
  max-width: 260px;
  text-align: center;
`;

const TooltipTrigger = styled.div`
  display: inline-block;
  cursor: not-allowed;
`;

interface PermissionDisabledTooltipProps {
  children: React.ReactNode;
  message?: string;
}

export default function PermissionDisabledTooltip({
  children,
  message = DISABLED_MESSAGE,
}: PermissionDisabledTooltipProps) {
  const tooltipId = useMemo(
    () => `permission-disabled-tooltip-${nanoid()}`,
    [],
  );

  return (
    <>
      <StyledTooltip id={tooltipId} place="top" size="small">
        {message}
      </StyledTooltip>
      <TooltipTrigger
        data-tip
        data-for={tooltipId}
        tabIndex={0}
        aria-describedby={tooltipId}
      >
        {children}
      </TooltipTrigger>
    </>
  );
}

export { DISABLED_MESSAGE };
